import React, { createContext, useContext, useState, useEffect } from "react";

interface HeaderContextType {
  submittedBy: string;
  submittedDate: string;
  signOffBy: string;
  signOffDate: string;
  landscapeName: string;
  commentStatus: string;
  refreshDate: string;
  updateHeaderInfo: (data: {
    submittedBy?: string;
    submittedDate?: string;
    signOffBy?: string;
    signOffDate?: string;
    landscapeName?: string;
    commentStatus?: string;
    refreshDate?:  string;
  }) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const HeaderProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [submittedBy, setSubmittedBy] = useState("");
  const [submittedDate, setSubmittedDate] = useState("");
  const [signOffBy, setSignOffBy] = useState("");
  const [signOffDate, setSignDate] = useState("");
  const [landscapeName, setLandscapeName] = useState("");
  const [commentStatus, setCommentStatus] = useState("");
  const [refreshDate, setRefreshDate] = useState("");

  const updateHeaderInfo = (data: {
    submittedBy?: string;
    submittedDate?: string;
    signOffBy?: string;
    signOffDate?: string;
    landscapeName?: string;
    commentStatus?: string;
    refreshDate?:  string;
  }) => {
    if (data.submittedBy !== undefined) {
      setSubmittedBy(data.submittedBy);
    }
    if (data.submittedDate !== undefined) {
      setSubmittedDate(data.submittedDate);
    }
    if (data.signOffBy !== undefined) {
      setSignOffBy(data.signOffBy);
    }
    if (data.signOffDate !== undefined) {
      setSignDate(data.signOffDate);
    }
    if (data.landscapeName !== undefined) {
      setLandscapeName(data.landscapeName);
    }
    if (data.commentStatus !== undefined) {
      setCommentStatus(data.commentStatus);
    }
    if (data.refreshDate !== undefined) {
      setRefreshDate(data.refreshDate);
    }
  };

  return (
    <HeaderContext.Provider
      value={{
        submittedBy,
        submittedDate,
        signOffBy,
        signOffDate,
        updateHeaderInfo,
        landscapeName,
        commentStatus,
        refreshDate,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error("useHeader must be used within HeaderProvider");
  }
  return context;
};
